import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c47be08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionSolutionView" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "comment" }, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

import { onMounted, ref, withDefaults } from "vue";
import { useRoute, useRouter } from "vue-router";
import { QuestionSolutionControllerService } from "../../../generated/services/QuestionSolutionControllerService";
import message from "@arco-design/web-vue/es/message";
import MDViewer from "@/components/MDViewer.vue";
import { QuestionSolutionCollectControllerService } from "../../../generated/services/QuestionSolutionCollectControllerService";
import moment from "moment";
import { useStore } from "vuex";
import {
  CommentReportControllerService,
  QuestionSolutionComment,
  QuestionSolutionCommentControllerService,
  QuestionSolutionReportControllerService,
} from "../../../generated";
import { Message } from "@arco-design/web-vue";

interface Props {
  questionSolutionId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionSolutionView',
  props: {
    questionSolutionId: { default: () => "" }
  },
  setup(__props: any) {

const router = useRouter();
const route = useRoute();

// 获取题解id
const props = __props;

// 获取登录用户
const store = useStore();
let loginUser = store.state.user.loginUser;

// 题解
const questionSolution = ref({
  comments: 0,
  content: "",
  createTime: "",
  id: 0,
  isDelete: 0,
  isLike: false,
  likes: 0,
  questionId: 0,
  tags: "",
  title: "",
  updateTime: "",
  userAvatar: "",
  userId: 0,
  userName: "",
});

// 是否收藏题解
const isCollet = ref(false);

// 评论
const comments = ref([]);
const commentNum = ref(0);
const firstCommentNum = ref(0);
const commentsSearchParams = ref({
  current: 1,
  pageSize: 10,
  solutionId: props.questionSolutionId,
  sortField: "createTime",
  sortOrder: "ascend",
});
const replyContent = ref("");
const firstReplyContent = ref("");
const secondReplyContent = ref("");

onMounted(async () => {
  await getQuestionSolution();
  await isCollectQuestionSolution();
  await getComments();
});

const onCommentsPageChange = async (page: number) => {
  commentsSearchParams.value = {
    ...commentsSearchParams.value,
    current: page,
  };
  await getComments();
};

const onCommentsPageSizeChange = async (size: number) => {
  commentsSearchParams.value = {
    ...commentsSearchParams.value,
    pageSize: size,
  };
  await getComments();
};

/**
 * 获取题解
 */
const getQuestionSolution = async () => {
  const res =
    await QuestionSolutionControllerService.getQuestionSolutionByIdUsingGet(
      props.questionSolutionId as any
    );
  if (res.code == 0) {
    questionSolution.value = res.data as any;
  } else {
    message.error("" + res.message);
  }
};

/**
 * 判断当前用户是否收藏该题解
 */
const isCollectQuestionSolution = async () => {
  const res =
    await QuestionSolutionCollectControllerService.isQuestionSolutionCollectUsingPost(
      props.questionSolutionId
    );
  if (res.code == 0) {
    isCollet.value = res.data;
  } else {
    message.error("" + res.message);
  }
};

/**
 * 收藏题解
 */
const collectQuestionSolution = async () => {
  const res =
    await QuestionSolutionCollectControllerService.addQuestionSolutionCollectUsingPost(
      {
        solutionId: props.questionSolutionId,
      }
    );
  if (res.code == 0) {
    await isCollectQuestionSolution();
    message.success("收藏成功");
  } else {
    message.error("收藏失败");
  }
};

/**
 * 取消收藏
 */
const unCollectQuestionSolution = async () => {
  const res =
    await QuestionSolutionCollectControllerService.deleteQuestionSolutionCollectUsingPost(
      props.questionSolutionId
    );
  if (res.code == 0) {
    await isCollectQuestionSolution();
    message.success("取消收藏成功");
  } else {
    message.error("取消收藏失败");
  }
};

/**
 * 点赞/取消点赞题解
 */
const likeQuestionSolution = async () => {
  const res =
    await QuestionSolutionControllerService.likeQuestionSolutionUsingPost(
      props.questionSolutionId
    );
  if (res.code == 0) {
    await getQuestionSolution();
  } else {
    message.error("点赞失败，" + res.message);
  }
};

/**
 * 举报题解
 * @param solutionId
 * @param reportedUserId
 */
const reportSolution = async (solutionId: number, reportedUserId: number) => {
  const res =
    await QuestionSolutionReportControllerService.addQuestionSolutionReportUsingPost(
      {
        solutionId: solutionId,
        reportedUserId: reportedUserId,
      }
    );
  if (res.code == 0) {
    Message.success("举报成功");
  } else {
    Message.error("举报失败：" + res.message);
  }
};

/**
 * 获取评论列表
 */
const getComments = async () => {
  const res =
    await QuestionSolutionCommentControllerService.listQuestionSolutionCommentUsingPost(
      commentsSearchParams.value
    );
  if (res.code == 0) {
    comments.value = res.data.result;
    commentNum.value = res.data.commentNum;
    firstCommentNum.value = res.data.total;
  }
};

/**
 * 点击回复或者取消按钮，修改回复框的显示状态
 * @param comment
 */
const toggleReplyBox = (comment: QuestionSolutionComment) => {
  comment.showReplyBox = !comment.showReplyBox;
};

/**
 * 发表或者回复评论
 * @param questionId
 * @param parentId
 * @param respondUserId
 */
const publisOrReply = async (
  solutionId: number,
  parentId: number,
  respondUserId: number
) => {
  const res =
    await QuestionSolutionCommentControllerService.publishQuestionSolutionCommentUsingPost(
      {
        solutionId: solutionId,
        parentId: parentId,
        respondUserId: respondUserId,
        content:
          parentId == 0
            ? replyContent.value
            : respondUserId == 0
            ? firstReplyContent.value
            : secondReplyContent.value,
      }
    );
  if (res.code == 0) {
    await getComments();
    Message.success("评论成功");
    if (parentId == 0) {
      replyContent.value = "";
    } else if (respondUserId == 0) {
      firstReplyContent.value = "";
    } else {
      secondReplyContent.value = "";
    }
  } else {
    Message.error("评论失败：" + res.message);
  }
};

/**
 * 点赞评论
 * @param commmntId
 */
const likeComment = async (commmntId: number) => {
  const res =
    await QuestionSolutionCommentControllerService.likeQuestionSolutionCommentUsingPost(
      commmntId
    );
  if (res.code == 0) {
    await getComments();
  } else {
    Message.error(res.message);
  }
};

/**
 * 删除评论
 * @param commentId
 */
const deleteComment = async (commentId: number) => {
  const res =
    await QuestionSolutionCommentControllerService.deleteQuestionSolutionCommentUsingPost(
      {
        id: commentId,
      }
    );
  if (res.code == 0) {
    await getComments();
    Message.success("删除成功");
  } else {
    Message.error("删除失败：" + res.message);
  }
};

/**
 * 举报评论
 * @param commentType 评论类型
 * @param commentId 评论id
 * @param reportedUserId 被举人id
 */
const reportComment = async (
  commentType: number,
  commentId: number,
  reportedUserId: number
) => {
  const res = await CommentReportControllerService.addCommentReportUsingPost({
    commentType: commentType,
    commentId: commentId,
    reportedUserId: reportedUserId,
  });
  if (res.code == 0) {
    Message.success("举报成功");
  } else {
    Message.error("举报失败：" + res.message);
  }
};

/**
 * 点击头像进行跳转
 * @param userId
 */
const goToUser = (userId: number) => {
  if (userId == loginUser.id) {
    router.push({
      path: `/mine`,
    });
  } else {
    router.push({
      path: `/Ta/${userId}`,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_icon_arrow_left = _resolveComponent("icon-arrow-left")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_overflow_list = _resolveComponent("a-overflow-list")!
  const _component_icon_star_fill = _resolveComponent("icon-star-fill")!
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconMessage = _resolveComponent("IconMessage")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_icon_exclamation_circle = _resolveComponent("icon-exclamation-circle")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_comment = _resolveComponent("a-comment")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_IconDelete = _resolveComponent("IconDelete")!
  const _component_a_collapse_item = _resolveComponent("a-collapse-item")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (questionSolution.value.content)
      ? (_openBlock(), _createBlock(_component_a_card, {
          key: 0,
          onClick: _cache[2] || (_cache[2] = () => {})
        }, {
          title: _withCtx(() => [
            _createVNode(_component_a_button, {
              style: {"color":"gray","font-size":"23px"},
              type: "text",
              onClick: _cache[0] || (_cache[0] = 
            () => {
              _unref(router).push(
                _unref(route).fullPath.substring(
                  0,
                  _unref(route).fullPath.lastIndexOf('s') - 1
                ) + '?tab=answers'
              );
            }
          )
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icon_arrow_left)
              ]),
              _: 1
            })
          ]),
          extra: _withCtx(() => [
            _createVNode(_component_a_space, { wrap: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_overflow_list, {
                  style: {"width":"455px","margin-top":"0px"},
                  min: "4",
                  margin: "8"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(questionSolution.value.tags), (tag, index) => {
                      return (_openBlock(), _createBlock(_component_a_tag, {
                        key: index,
                        color: "gray",
                        style: {"border-radius":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                (isCollet.value)
                  ? (_openBlock(), _createBlock(_component_icon_star_fill, {
                      key: 0,
                      style: {"font-size":"23px","color":"rgb(247, 186, 30)"},
                      onClick: unCollectQuestionSolution
                    }))
                  : (_openBlock(), _createBlock(_component_icon_star_fill, {
                      key: 1,
                      style: {"font-size":"23px","color":"rgb(229, 230, 235)"},
                      onClick: collectQuestionSolution
                    })),
                (questionSolution.value.isLike)
                  ? (_openBlock(), _createBlock(_component_IconHeartFill, {
                      key: 2,
                      style: {"font-size":"23px","color":"red"},
                      onClick: likeQuestionSolution
                    }))
                  : (_openBlock(), _createBlock(_component_IconHeart, {
                      key: 3,
                      style: {"font-size":"23px","color":"gray"},
                      onClick: likeQuestionSolution
                    })),
                _createTextVNode(" " + _toDisplayString(questionSolution.value.likes) + " ", 1),
                _createVNode(_component_a_link, {
                  href: "#comment",
                  style: {"color":"black","background-color":"rgb(255, 255, 255, 0)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconMessage, { style: {"font-size":"23px","color":"gray"} }),
                    _createTextVNode(_toDisplayString(commentNum.value), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tooltip, { content: '举报' }, {
                  default: _withCtx(() => [
                    (questionSolution.value.userId != _unref(loginUser).id)
                      ? (_openBlock(), _createBlock(_component_icon_exclamation_circle, {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (
                reportSolution(questionSolution.value.id, questionSolution.value.userId)
              )),
                          style: {"font-size":"23px","color":"gray"}
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(MDViewer, {
              value: questionSolution.value.content || ''
            }, null, 8, ["value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createVNode(_component_a_comment, {
      id: "publish",
      align: "right",
      avatar: _unref(loginUser).userAvatar
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "1",
          type: "primary",
          status: "success",
          shape: "round",
          disabled: replyContent.value == '',
          onClick: _cache[3] || (_cache[3] = ($event: any) => (publisOrReply(props.questionSolutionId, 0, 0)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 评论 ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_a_input, {
          modelValue: replyContent.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((replyContent).value = $event)),
          placeholder: "Here is you content."
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["avatar"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (firstComment) => {
      return (_openBlock(), _createBlock(_component_a_comment, {
        author: firstComment.userName,
        content: firstComment.content,
        datetime: _unref(moment)(firstComment.createTime).format('YYYY-MM-DD HH:mm:ss')
      }, {
        avatar: _withCtx(() => [
          _createVNode(_component_a_avatar, {
            onClick: ($event: any) => (goToUser(firstComment.userId)),
            size: 32
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: firstComment.userAvatar
              }, null, 8, _hoisted_3)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        actions: _withCtx(() => [
          _createElementVNode("span", {
            class: "action",
            key: "heart",
            onClick: ($event: any) => (likeComment(firstComment.id))
          }, [
            (firstComment.isLike)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createVNode(_component_IconHeart)
                ])),
            _createTextVNode(" " + _toDisplayString(firstComment.likes), 1)
          ], 8, _hoisted_4),
          _createElementVNode("span", {
            class: "action",
            key: "reply",
            onClick: ($event: any) => (toggleReplyBox(firstComment))
          }, [
            _createVNode(_component_IconMessage),
            _createTextVNode(" Reply ")
          ], 8, _hoisted_7),
          (firstComment.userId == _unref(loginUser).id)
            ? (_openBlock(), _createElementBlock("span", {
                class: "action",
                key: "delete",
                onClick: ($event: any) => (deleteComment(firstComment.id))
              }, [
                _createVNode(_component_a_tooltip, { content: '删除' }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconDelete)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("span", {
                class: "action",
                key: "report",
                onClick: ($event: any) => (reportComment(1, firstComment.id, firstComment.userId))
              }, [
                _createVNode(_component_a_tooltip, { content: '举报' }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_exclamation_circle)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_9))
        ]),
        default: _withCtx(() => [
          (firstComment.showReplyBox)
            ? (_openBlock(), _createBlock(_component_a_comment, {
                key: 0,
                align: "right",
                avatar: _unref(loginUser).userAvatar
              }, {
                actions: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    key: "0",
                    type: "secondary",
                    shape: "round",
                    onClick: ($event: any) => (toggleReplyBox(firstComment))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    key: "1",
                    type: "primary",
                    status: "success",
                    shape: "round",
                    disabled: firstReplyContent.value == '',
                    onClick: ($event: any) => (publisOrReply(props.questionSolutionId, firstComment.id, 0))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Reply ")
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    modelValue: firstReplyContent.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((firstReplyContent).value = $event)),
                    placeholder: "Here is you content."
                  }, null, 8, ["modelValue"])
                ]),
                _: 2
              }, 1032, ["avatar"]))
            : _createCommentVNode("", true),
          (firstComment.childList.length != 0)
            ? (_openBlock(), _createBlock(_component_a_collapse, {
                key: 1,
                "default-active-key": [1],
                accordion: "",
                bordered: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_item, {
                    header: firstComment.childList.length + '条回复',
                    key: "1"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstComment.childList, (secondComment) => {
                        return (_openBlock(), _createBlock(_component_a_comment, {
                          author: 
              secondComment.userName +
              '' +
              (secondComment.respondUserId == 0
                ? ''
                : ' 回复 ' + secondComment.respondUserName)
            ,
                          content: secondComment.content,
                          datetime: 
              _unref(moment)(secondComment.createTime).format('YYYY-MM-DD HH:mm:ss')
            
                        }, {
                          avatar: _withCtx(() => [
                            _createVNode(_component_a_avatar, {
                              onClick: ($event: any) => (goToUser(secondComment.userId)),
                              size: 32
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: secondComment.userAvatar
                                }, null, 8, _hoisted_10)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          actions: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "action",
                              key: "heart",
                              onClick: ($event: any) => (likeComment(secondComment.id))
                            }, [
                              (secondComment.isLike)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                    _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } })
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                    _createVNode(_component_IconHeart)
                                  ])),
                              _createTextVNode(" " + _toDisplayString(secondComment.likes), 1)
                            ], 8, _hoisted_11),
                            _createElementVNode("span", {
                              class: "action",
                              key: "reply",
                              onClick: ($event: any) => (toggleReplyBox(secondComment))
                            }, [
                              _createVNode(_component_IconMessage),
                              _createTextVNode(" Reply ")
                            ], 8, _hoisted_14),
                            (secondComment.userId == _unref(loginUser).id)
                              ? (_openBlock(), _createElementBlock("span", {
                                  class: "action",
                                  key: "delete",
                                  onClick: ($event: any) => (deleteComment(secondComment.id))
                                }, [
                                  _createVNode(_component_a_tooltip, { content: '删除' }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_IconDelete)
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_15))
                              : (_openBlock(), _createElementBlock("span", {
                                  class: "action",
                                  key: "report",
                                  onClick: ($event: any) => (
                  reportComment(1, secondComment.id, secondComment.userId)
                )
                                }, [
                                  _createVNode(_component_a_tooltip, { content: '举报' }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_icon_exclamation_circle)
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_16))
                          ]),
                          default: _withCtx(() => [
                            (secondComment.showReplyBox)
                              ? (_openBlock(), _createBlock(_component_a_comment, {
                                  key: 0,
                                  align: "right",
                                  avatar: _unref(loginUser).userAvatar
                                }, {
                                  actions: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      key: "0",
                                      type: "secondary",
                                      shape: "round",
                                      onClick: ($event: any) => (toggleReplyBox(secondComment))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Cancel ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_a_button, {
                                      key: "1",
                                      type: "primary",
                                      status: "success",
                                      shape: "round",
                                      disabled: secondReplyContent.value == '',
                                      onClick: ($event: any) => (
                    publisOrReply(
                      props.questionSolutionId,
                      firstComment.id,
                      secondComment.userId
                    )
                  )
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Reply ")
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"])
                                  ]),
                                  content: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      modelValue: secondReplyContent.value,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((secondReplyContent).value = $event)),
                                      placeholder: "Here is you content."
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["avatar"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["author", "content", "datetime"]))
                      }), 256))
                    ]),
                    _: 2
                  }, 1032, ["header"])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["author", "content", "datetime"]))
    }), 256)),
    _createVNode(_component_a_pagination, {
      style: {"position":"relative","top":"5px"},
      total: firstCommentNum.value,
      "show-page-size": "",
      simple: "",
      "show-total": "",
      current: commentsSearchParams.value.current,
      "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((commentsSearchParams.value.current) = $event)),
      "page-size": commentsSearchParams.value.pageSize,
      "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((commentsSearchParams.value.pageSize) = $event)),
      onChange: onCommentsPageChange,
      onPageSizeChange: onCommentsPageSizeChange
    }, null, 8, ["total", "current", "page-size"])
  ]))
}
}

})